import { AlertCircle } from 'lucide-react'
import * as React from 'react'

import { cn } from '../cn'
import { Label } from './label'

interface FormFieldProps {
  /** Field label text */
  label: string
  /** Matches the input's id for accessibility */
  htmlFor?: string
  /** Show red asterisk after label */
  required?: boolean
  /** Error message — also adds border-destructive to the first input child */
  error?: string
  /** Helper text below the input */
  helperText?: string
  /** Additional className on the wrapper div */
  className?: string
  children: React.ReactNode
}

function FormField({ label, htmlFor, required, error, helperText, className, children }: FormFieldProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <Label htmlFor={htmlFor}>
        {label}
        {required && <span className="text-destructive"> *</span>}
      </Label>
      {children}
      {helperText && !error && <p className="text-xs text-muted-foreground">{helperText}</p>}
      {error && (
        <p className="text-sm text-destructive flex items-center gap-1">
          <AlertCircle className="h-3 w-3 shrink-0" />
          {error}
        </p>
      )}
    </div>
  )
}

export { FormField, type FormFieldProps }
